import { ContextProps } from '../context/AppContext';
import { InitDataBaseProps } from '../types/initData';

// ### Function accepts sex Id and returns sex Code

export const getSexCode = (id: number, ctx: ContextProps) => {
    return ctx.initData?.Lovs.Sex.find((s: InitDataBaseProps) => s.Id === id)?.Code || '';
};
